import { BaseSyntheticEvent, Dispatch, FC, SetStateAction } from 'react';
import { FieldValues, UseFormReturn } from 'react-hook-form';
import { AutomatedAccountsDTO } from './api/useAutomatedAccountsQuery';

export enum FinancialGoal {
  LongTerm = 'longTerm',
  Retirement = 'retirement',
  RiskTolerance = 'riskTolerance',
}

interface CurrentStepProps {
  data: AutomatedAccountsDTO;
  onNext(): void;
}

export type WorkflowCurrentStepFC = FC<CurrentStepProps>;

export interface WorkflowData<CurrentStep> {
  progress: number;
  isFirstStep: boolean;
  isLastStep: boolean;
  CurrentStep: CurrentStep;
  isLoading: boolean;
  showNextButton?: boolean;
}

export interface WorkflowActions<FormFields extends FieldValues> {
  formBag: UseFormReturn<FormFields>;
  nextStep: Dispatch<SetStateAction<void>>;
  onSubmit: (e?: BaseSyntheticEvent) => Promise<void>;
  previousStep: Dispatch<SetStateAction<void>>;
  validateCurrentStep: () => Promise<boolean>;
}
